var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GChart',{attrs:{"data":_vm.chartData,"type":'BarChart',"options":_vm.chartOptions,"events":_vm.chartEvents}}),(_vm.detail)?_c('GChart',{attrs:{"data":_vm.chartDetailData,"type":'BarChart',"options":_vm.chartDetailOptions,"events":_vm.chartEvents}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }